const MAP_KEY = "d3e1d4f3ad10bb99c6b15d2b9f8bc521";
const MAP_SECRET = "8a48034adcf8700e53d75d5f3adc08cb";
const AGENT_ID = "7596562";
const AGENT_MD = "cee40804a5b2c83c";
const UID = "1";

export {
    MAP_KEY,
    MAP_SECRET,
    AGENT_ID,
    AGENT_MD,
    UID
};